/*
tslint:disable:import-spacing no-inferrable-types
variable-name align no-trailing-whitespace component-class-suffix
no-string-literal component-selector
*/

import 'ag-grid-enterprise';
import {ICellRenderer, ICellRendererParams} from "ag-grid-community";

/**
 *
 * @class DiversionNameRenderer
 *
 * @brief cell rendering for the diversion name
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      July 2020
 *
 */
export class DiversionNameRenderer implements ICellRenderer {

  /** agGrid DOM element for display */
  public gui: HTMLElement;

  /** the value being rendered */
  public value: any;

  /** first time creation of the rendered cell. */
  public init(params: ICellRendererParams): void {

    this.gui = document.createElement('div');
    this.gui.innerHTML = `<span style="color: grey;">Name...</span>`;

    /* render! */

    this.refresh(params);
  }

  /** return the currently rendered DOM */
  public getGui(): HTMLElement {

    return this.gui;
  }

  /** update the rendered DOM */
  public refresh(params: ICellRendererParams): boolean {

    this.value = params?.value?.trim();

    if (!this.value) {

      this.gui.innerHTML = `<span style="color: grey;">Name...</span>`;
      return ;
    }

    if (this.value.length >= 24) {

      this.value = this.value.substring(0, 24) + '...';
    }

    if (this.value) {

      this.gui.innerHTML = `<span>${this.value}</span>`;
    }

    return true;
  }

  /** destructor for rendered DOM */
  public destroy() {

  }

}
